import './CodeCard.scss';
import { RxCross2 } from 'react-icons/rx';
import React, { useState } from 'react';
import TextArea from 'antd/lib/input/TextArea';
import { t } from '../../../i18n/i18n';
import GenericToggle from '../../GenericToggle/GenericToggle';

function CodeCard({ index, question, preCode, handleDelete, id, setDataAI }) {
  const [hasInitialCode, setHasInitialCode] = useState(true);
  const handleUpdateData = (e, id) => {
    const { name, value } = e.target;

    setDataAI((prevState) =>
      prevState.map((item) => (item.id === id ? { ...item, [name]: value } : item))
    );
  };

  const resetInitalCode = () => {
    setDataAI((prevState) =>
      prevState.map((item) => (item.id === id ? { ...item, preCode: '' } : item))
    );
  };

  return (
    <div className="code-card-container">
      <div className="code-card-index-badge">
        <span>{index}</span>
      </div>
      <div className="code-card-content">
        <div className="code-card-fields">
          <span className="card-text">{t('TEXT_SPAN_QUESTION_MODAL_AI_SUGESTION')}: </span>
          <TextArea
            name="question"
            className={`code-card-textarea ${question?.length ? 'selected-border' : 'unselected-border'
              }`}
            rows="4"
            placeholder={t('CREATE_SCREENING_YOUR_QUESTIONS_CODE_INPUT_PLACEHOLDER')}
            onChange={(e) => handleUpdateData(e, id)}
            value={question ?? ''}
            maxLength={5000}
            data-testid="question-text-textarea"
          />

          <GenericToggle
            className="my-3"
            rightText={t('TOGGLE_HAS_INITAL_CODE')}
            defaultActive={hasInitialCode}
            actionFunction={() => {
              resetInitalCode();
              setHasInitialCode(!hasInitialCode);
            }}
          />

          {hasInitialCode && (
            <TextArea
              name="preCode"
              className={`code-card-textarea ${preCode?.length ? 'selected-border' : 'unselected-border'
                }`}
              rows="5"
              placeholder={t('CREATE_SCREENING_YOUR_QUESTIONS_CODE_INPUT_PLACEHOLDER')}
              onChange={(e) => handleUpdateData(e, id)}
              value={preCode ?? ''}
              maxLength={5000}
              data-testid="question-text-textarea"
            />
          )}
        </div>
      </div>
      <div className="code-card-remove">
        <RxCross2 onClick={() => handleDelete(id)} />
      </div>
    </div>
  );
}

export default CodeCard;
